/*
	Generated on 29/04/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.9.0
*/
import React, { useEffect, useState, useContext} from 'react'
import { Button, Spinner } from "@/commons/components"
import * as Layouts from '@/commons/layouts';
import { Link } from "react-router";
import { useParams } from "@/commons/hooks/useParams"
import { HeaderContext } from "@/commons/components"
import { useNavigate } from "react-router";
import { useAuth } from '@/commons/auth';
import StudiTable from "../components/StudiTable";

import getProgramStudiDataList from '../services/getProgramStudiDataList'
const PilihProgramStudiPage = props => {
const { checkPermission } = useAuth();

	const [isLoading, setIsLoading] = useState({
	programStudi: false,

	});
	const { setTitle } = useContext(HeaderContext);

const [programStudiDataList, setProgramStudiDataList] = useState()
	
	
	
	useEffect(() => {
		

		const fetchData = async () => {
			try {
				setIsLoading(prev => ({...prev, programStudi: true}))
				const { data: programStudiDataList } = await getProgramStudiDataList()
				setProgramStudiDataList(programStudiDataList.data)
			} finally {
				setIsLoading(prev => ({...prev, programStudi: false}))
			}
		}
		fetchData()
  	}, [])

	
	useEffect(() => {
		setTitle("Pilih Program Studi Page")
	}, []);
return (
	<Layouts.ViewContainerLayout
		buttons={
			<>
			<></>
			</>
		}
	>
<Layouts.ListContainerTableLayout
	title={"Program Studi"}
	singularName={"Studi"}
	items={[programStudiDataList]}
	isLoading={isLoading.programStudi}
>
	<StudiTable
		programStudiDataList={programStudiDataList}
		
	/>
</Layouts.ListContainerTableLayout>

	</Layouts.ViewContainerLayout>
  )
}
export default PilihProgramStudiPage

